import React, { useEffect, useRef, useState } from 'react';
import { IconButton, Tooltip } from '@mui/joy';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

/** Copy payment link with temporary success checkmark (same UX as invoice manager). */
export default function CopyPaymentLinkButton({ paymentLink, tooltip }) {
  const [copied, setCopied] = useState(false);
  const resetTimeoutRef = useRef(null);

  const handleClick = (e) => {
    e.stopPropagation();
    setCopied(true);
    navigator.clipboard.writeText(paymentLink);
    if (resetTimeoutRef.current) {
      clearTimeout(resetTimeoutRef.current);
    }
    resetTimeoutRef.current = setTimeout(() => {
      setCopied(false);
      resetTimeoutRef.current = null;
    }, 2000);
  };

  useEffect(() => {
    return () => {
      if (resetTimeoutRef.current) {
        clearTimeout(resetTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={handleClick}>
        {copied ? (
          <CheckCircleIcon color="success" />
        ) : (
          <ContentCopyIcon />
        )}
      </IconButton>
    </Tooltip>
  );
}
